export const config = {
	btn: {
		elevation: 0,
		color: 'transparent'
	},
	icon: {
		class: 'mr-2'
	}
};
